import { uuidv4 } from "@-/com.npmjs.uuid";

/**
 * The identity of one ATTEMPT to act on a card. Generated when the learner commits and kept for
 * the whole of that action's life — through a retry after a lost outcome, and through the
 * successor loading and failing and being retried — so that:
 *
 *   * the review rows are named after it (see {@link learnCardReviewIdsForOperation}), which makes
 *     the write durably idempotent: resubmitting the same operation cannot record a second review;
 *   * every completion event names the operation it belongs to, so a late callback from an
 *     abandoned attempt is recognisable and dropped rather than advancing the deck twice.
 */
export function createLearnCardOperationId(): string {
  return uuidv4();
}

/** A fresh Learn session id; results prepared under an older id are obsolete. */
export function createLearnCardSessionId(): string {
  return uuidv4();
}

/**
 * The deterministic row ids a review write uses for a given operation. A sentence commit writes
 * one review per rated word, hence the index. Derived, not random, so a retry names the SAME rows
 * and the persistence layer can see that they already exist.
 */
export function learnCardReviewIdsForOperation(
  operationId: string,
  reviewIndex = 0,
): { fsrsCardReviewLogId: string; userCardReviewId: string } {
  return {
    fsrsCardReviewLogId: `${operationId}:log:${reviewIndex}`,
    userCardReviewId: `${operationId}:review:${reviewIndex}`,
  };
}
